import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';

@Component({
  selector: 'app-cross-sell',
  templateUrl: './cross-sell.component.html',
  styleUrls: ['./cross-sell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CrossSellComponent {
  @Input() title: string;
  @Input() description: string;
  @Input() callToAction: string = '';
  @Input() imageSource: string;
  @Input() resellerId: string;
}
